import React, { useState } from 'react'      
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/images/wordb_logo.svg';
import { FaPlay } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import { FaRankingStar } from "react-icons/fa6";
import Feedback from '../components/Feedback';
import Query from '../components/Query';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API } from '../config';
import { Helmet } from "react-helmet-async";


const Landing = () => {

    const navigate = useNavigate();

    const [isFeedbackOpen, setFeedbackOpen] = useState(false);
    const [isQueryOpen, setQueryOpen] = useState(false);
    const toggleFeedback = () => setFeedbackOpen(open => !open);
    const toggleQuery = () => setQueryOpen(open => !open);

    const handleSinglePlayer = async () => {
        try {
            const token = localStorage.getItem('authToken');

            if (!token) {
                toast.info("Let's get you logged in first!");
                setTimeout(() => {
                    navigate("/login")
                }, 3000);
                return;
            }

            const response = await axios.post(
                `${API}/api/game/start-single-player`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            navigate(`/game/${response.data.roomId}`);
        } catch (error) {
            console.error('Error starting single-player game:', error);
        }
    };

    const handleMultiplayer = () => {

        const token = localStorage.getItem('authToken');

        if (!token) {
            toast.info("Let's get you logged in first!");
            setTimeout(() => {
                navigate("/login")
            }, 3000);
            return;
        }
        
        navigate('/lobby1');
    };



  return (
    <>
        <Helmet>
            <title>WordB — Multiplayer Word Game</title>
            <meta
                name="description"
                content="WordB is a multiplayer word game built for fast thinkers. Challenge friends, test your vocabulary, and compete in real-time word battles."
            />
        </Helmet>
        <ToastContainer position="top-right" autoClose={3000} />
        <section className='landing'>
           {isFeedbackOpen && <Feedback onClose={toggleFeedback}/>}
            {isQueryOpen && <Query onClose={toggleQuery}/>}
            
            <div className="logo-div">
                <img src={logo} alt="" />
            </div>

            <div className="returning-user">
                <p className="bold-title">
                    I already know this game, <br />
                    Let’s jump right in!
                </p>

                <button className='btn quick-play-btn' onClick={handleSinglePlayer}>
                    <span>Play Now</span>
                    <FaPlay className='icon'/>
                </button>

                <button className='btn multiplayer-btn' onClick={handleMultiplayer}>
                    <span>Multiplayer</span>
                    <FaPlay className='icon'/>
                </button>
            </div>

            <div className="new-user">
                <p className="bold-title">
                    I’m new here,  <br />
                    Show me around.
                </p>

                <div className="image-icon-div">
                    <img src="/assets/images/rounded-arrow.svg" alt="" />
                </div>

                <div className="texts">
                    <div className="what">
                        <p className="title">What is WordB?</p>
                        <p className="txt">
                            WordB is a word game with familiar gameplay and real-time leaderboards. Built to bring simple wordplay, put your brain to the test, and connect players through multiplayer games & live ranking.
                        </p>
                    </div>

                    <div className="how">
                        <p className="title">How to play?</p>
                        <p className="txt">
                            When it is your turn to play, use the last letter of the word shown to make a new word. The longer your word, the higher you score. <br />
                            No repeating words. No words over 10 letters. And watch the clock, time gets shorter with every turn! <br />
                            Think fast, type smart, and keep the chain going.
                        </p>

                          <div className="gif-box">
                              <video
                                  autoPlay
                                  muted
                                  loop
                                  playsInline
                                  preload="none"
                                  poster="/assets/images/how-to-play.webm"
                              >
                                  <source src="/assets/images/how-to-play.mp4" type="video/mp4" />
                              </video>
                          </div>

                          <Link to="/signup">
                              <button className="signup-button btn">
                                  <p className='btn-text'>Sign Up & Play</p> <FaArrowRight className="icon" />
                              </button>
                          </Link>
                    </div>
                </div>
            </div>

            <div className="to-board">
                <p className="bold-title">
                    Just one word away from <br />
                    being crowned Champion!
                </p>

                <p className="txt">
                    Your leaderboard rank is based on your latest score. Every game gives you a new chance to victory.
                </p>

                <Link to="/leaderboard">
                    <button className="to-board-btn btn">
                        <p className='btn-text'>See Leaderboard</p> 
                        <FaRankingStar className="icon" />
                    </button>
                </Link>
            </div>

            <div className="footer-landing">
                <p className="opens-modal feedback-cta" onClick={toggleFeedback}>Make this game better. Share your thoughts here</p>
                <p className="opens-modal help-cta" onClick={toggleQuery}>Need help? Reach out to us here</p>
            </div>
        </section>
    </>
  )
}

export default Landing